






















































































































import { uploadTaiwanStudentFile } from "@/apis/enroll/taiwanEnroll"
import BirthdayPicker from "@/components/exam/BirthdayPicker.vue"
import NationalSelect from "@/components/exam/NationalSelect.vue"
import PhotoUploader from "@/components/exam/PhotoUploader.vue"
import SexSelect from "@/components/exam/SexSelect.vue"
import type { TaiwanEnroll } from '@/models/enrolls/taiwanEnroll'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: { BirthdayPicker, NationalSelect, PhotoUploader, SexSelect }
})
export default class PersonalInfomationForm extends Vue {
  @Prop({ required: true }) value!: TaiwanEnroll
  @Prop({ default: false }) print!: boolean
  @Prop({ default: '' }) title!: string

  get form() {
    return this.value
  }

  set form(value: TaiwanEnroll) {
    if (!this.print) {
      this.$emit('update:value', value)
    }
  }

  uploadPhoto = uploadTaiwanStudentFile

  get photo() {
    return this.form.photoUrl
  }

  set photo(value: string) {
    const baseURL = process.env.VUE_APP_BASE_API
    this.form.photoUrl = `${baseURL}/student/TaiwanEnroll/files/${value}`
  }
}
